/** Wspólne okno czasu dla zakładek journey w Sprzedaż. */
export const JOURNEY_WINDOW_OPTIONS = [
  { id: "today", label: "Dziś" },
  { id: "yesterday", label: "Wczoraj" },
  { id: "7", label: "7 dni" },
  { id: "14", label: "14 dni" },
  { id: "30", label: "30 dni" },
] as const;

export type JourneyWindowId = (typeof JOURNEY_WINDOW_OPTIONS)[number]["id"];

export function journeyWindowParams(period: JourneyWindowId): {
  period?: string;
  days?: number;
} {
  if (period === "today" || period === "yesterday") {
    return { period };
  }
  return { days: Number(period) };
}
